export default __webpack_public_path__ + "static/14_16-240ea7eff975ac2a59220292f4f9c2c3.png";